import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";
import { Phone, Mail, MapPin } from "lucide-react";
import logo from "@/assets/fl-cars-logo.png";

export const Footer = () => {
  const settings = useSettings();
  return (
    <footer className="relative z-10 border-t border-slate-200 bg-[#EEF3FC]">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <img src={logo} alt="F&L Cars" className="h-20 w-auto" />
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-600">Premium Vehicles. Flexible Financing. Your trusted partner for luxury automotive financing across the United States.</p>
          </div>
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-900">Explore</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><Link to="/inventory" className="hover:text-gold">Inventory</Link></li>
              <li><Link to="/financing" className="hover:text-gold">Financing</Link></li>
              <li><Link to="/how-it-works" className="hover:text-gold">How It Works</Link></li>
              <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-900">Legal</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><Link to="/privacy" className="hover:text-gold">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-gold">Terms &amp; Conditions</Link></li>
              <li><Link to="/financing-disclosure" className="hover:text-gold">Financing Disclosure</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-slate-900">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold" /> {settings?.company_phone}</li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold" /> {settings?.company_email}</li>
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-gold" /> {settings?.company_address}</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-slate-200 pt-6">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} F&amp;L Cars. All rights reserved. Financing calculator results are estimates only and do not constitute a financing offer or approval until a financing agreement is formally approved.</p>
        </div>
      </div>
    </footer>
  );
};
